import { memo } from 'react';

const CanShow = memo(({ show, children, fallbackComponent = null }) => {
  if (show) {
    return children;
  }
  return fallbackComponent || null;
});

export default CanShow;
